import React, { useState } from 'react';
import { apiGenerateImageAI } from '../../../../assets/api/generateImageAI';
import './ImageGeneration.scss';

const ImageGeneration = ({ formData, setFormData, setCurrentStep, onBack }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleGenerateImage = async () => {
    if (!formData.content || formData.content.length < 100) {
      setError("O conteúdo precisa ter pelo menos 100 caracteres para gerar a imagem.");
      return;
    }
    if (!formData.listTagsID || formData.listTagsID.length === 0) {
      setError("É necessário adicionar pelo menos uma tag.");
      return;
    }

    try {
      setError("");
      setLoading(true);
      const payload = {
        content: formData.content,
        tags: formData.listTagsID.map(id => id.toString())
      };

      const response = await apiGenerateImageAI(payload);

      setFormData(prev => ({
        ...prev,
        imageUrl: response
      }));

    } catch (error) {
      setError("Erro ao gerar a imagem. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ImageGeneration">
      {formData.imageUrl && !loading && (
        <div className="container-image-preview">
          <div className="image-preview">
            <img src={formData.imageUrl} alt="Imagem gerada" style={{ maxWidth: "100%", height: "auto" }} />
          </div>

          <h2>Parabéns! Sua imagem foi gerada com sucesso!</h2>
          <p>Agora você pode usá-la como quiser.</p>

          <button className="generate-button" onClick={handleGenerateImage}>Gerar outra imagem</button>
        </div>

      )}
      {!formData.imageUrl && !loading && (
        <>
          <div className="description">
            <h2>Pronto para gerar a imagem perfeita?</h2>
            <p>Usaremos o conteúdo e as tags escolhidas para criar uma imagem personalizada incrível.</p>
          </div>

          <button className="generate-button" onClick={handleGenerateImage}>
            Gerar Imagem
          </button>
        </>
      )}
      {loading && (
        <div className="loading-container">
          <div className="clock">
            <div className="clock-face">
              <div className="hand short"></div>
              <div className="hand long"></div>
            </div>
          </div>
          <div className="loading-text">
            <h2>Gerando imagem...</h2>
            <p>Isso pode levar alguns segundos.</p>
          </div>
        </div>
      )}
      {!formData.imageUrl && error && <div className="error-message">{error}</div>}
      <button className="back-button" onClick={onBack}>
        Voltar
      </button>
      <button
        onClick={() => {
          if (!formData.imageUrl) {
            setError("Você precisa gerar uma imagem antes de continuar.");
            return;
          }

          setError("");
          setCurrentStep("Revisão");
        }}
        className="continue-button"
      >
        Continuar
      </button>

    </div>
  );
};

export default ImageGeneration;
